import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Alert } from '@mui/material';
import axios from 'axios';
import { API } from './customerApp/shared';
import { setOwnerUnlock } from '../utils/ownerSession';

/**
 * Second password check for the Owner Console. Posts to /api/owner/unlock and
 * stores the 30-minute token; `onUnlocked` lets the caller retry what it was
 * doing. `onCancel` is only offered when the dialog was opened on demand.
 */
export default function UnlockDialog({ open, onUnlocked, onCancel }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e?.preventDefault();
    if (!password) return;
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post(`${API}/api/owner/unlock`, { password }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setOwnerUnlock(data.ownerToken, data.expiresAt);
      setPassword('');
      onUnlocked?.(data);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not unlock. Check your connection and try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={onCancel || undefined} maxWidth="xs" fullWidth component="form" onSubmit={submit}>
      <DialogTitle>Unlock the Owner Console</DialogTitle>
      <DialogContent sx={{ display: 'grid', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          This area holds applicant, affiliate and advertising data, so it asks for your password again.
          The unlock lasts 30 minutes in this tab.
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          autoFocus type="password" label="Your password" value={password} onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password" fullWidth size="small" disabled={busy}
        />
      </DialogContent>
      <DialogActions>
        {onCancel && <Button onClick={onCancel} disabled={busy}>Cancel</Button>}
        <Button type="submit" variant="contained" disabled={busy || !password}>{busy ? 'Checking…' : 'Unlock for 30 minutes'}</Button>
      </DialogActions>
    </Dialog>
  );
}
